export interface IDateParts {
  date: string;
  month: string;
  year: string;
}

const partsFromDate = (date: any) =>
  date && date instanceof Date && !isNaN(date.getTime())
    ? {
        date: date.getDate().toString().padStart(2, '0'),
        month: (date.getMonth() + 1).toString().padStart(2, '0'),
        year: date.getFullYear().toString().padStart(4, '0'),
      }
    : null;

export const generateDateText = (dateParts?: IDateParts | null) =>
  dateParts ? `${dateParts.month}/${dateParts.date}/${dateParts.year}` : '__/__/____';

export default partsFromDate;
